import { InitialPageColors } from 'modules/Editor/components/WidgetMenu/SideMenu/BrandKitMenu/ApplyColorTheme/colorShuffle.types';
import { ImageMeta } from 'modules/Editor/components/WidgetMenu/SideMenu/BrandKitMenu/ApplyLogo/ApplyLogo.helpers';
import { UpdateWidget } from 'modules/Editor/store/infographSlice.types';

import { BrandTemplateData } from './BrandTemplatePreview.type';

export const previewBrandTemplateCache = new Map<string, BrandTemplateData>();
export const colorShuffleCache = new Map<string, ColorShuffleCache>();
export const logoShuffleCache = new Map<string, ImageMeta>();

export const addLatestBrandTemplate = (brandData: BrandTemplateData) => {
  previewBrandTemplateCache.set(brandData.templateId, brandData);
  previewBrandTemplateCache.set('latest', brandData);
};

export const getLatestBrandTemplate = (templateId = '') => {
  if (templateId) {
    return previewBrandTemplateCache.get(templateId);
  }
  return previewBrandTemplateCache.get('latest');
};

interface ColorShuffleCache {
  updatePageColors: InitialPageColors;
  updateWidgets: UpdateWidget[];
}

/**
 * Adds a given color shuffle cache to the global color shuffle cache map.
 *
 * @param colorShuffle - The color shuffle cache containing updated page colors and widget updates.
 * @param infographId - The identifier of the infograph to associate with the given color shuffle cache.
 */
export const addColorCache = (colorShuffle: ColorShuffleCache, infographId: string) => {
  colorShuffleCache.set(infographId, colorShuffle);
};

/**
 * Retrieves a color shuffle cache from the global color shuffle cache map by infographId.
 *
 * @param templateId - The identifier of the infograph to retrieve the color shuffle cache for.
 * @returns The color shuffle cache containing updated page colors and widget updates.
 */
export const getColorCache = (templateId = '') => {
  return colorShuffleCache.get(templateId);
};

/**
 * Adds a logo to the global logo shuffle cache map.
 *
 * @param image - The logo ImageMeta to cache.
 * @param templateId - The identifier of the template to associate with the logo.
 */
export const addLogoCache = (image: ImageMeta, templateId: string) => {
  logoShuffleCache.set(templateId, image);
};

/**
 * Retrieves a logo from the global logo shuffle cache map by templateId.
 *
 * @param templateId - The identifier of the template to retrieve the logo for.
 * @returns The logo string associated with the given templateId.
 */
export const getLogoCache = (templateId = '') => {
  return logoShuffleCache.get(templateId);
};
